"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var segmenter_1 = require("./src/segmenter");
Object.defineProperty(Intl, 'Segmenter', {
    value: segmenter_1.Segmenter,
    enumerable: false,
    writable: true,
    configurable: true,
});
